import { SC } from "../helper/ServerCall";

export const brandService = {
    getAllListTypes,
    getListType,
    getBrandsList,
    storeBrand,
    editList,
    deleteBrand,
    getListItem,
    storeBrandProductAtts,
    storeBrandOrderAtts,
    storeBrandExportAtts,
    getBrandDataWithKey,
    getBrandProductData,
    getAllBrands,
    storeCustomerBrand,
    getAllCustomerBrands,
    deleteCustomerBrand,
    storeBrandDataDefinition,
    getBrandDataDefinitions,
    editBrandDataDefinition,
    saveTagLayout,
    getBrandTagLayoutsPagination,
    deleteTagLayout,
    getTagLayout,
    updateTagLayout,
    storeTransformationRules,
    storeBrandLookupTable,
    getBrandLookupDefinitionsPagination,
    getBrandsListDropdown,
    getBrandLookupDefinitionsData,
    getTransformationRulesListing,
    markActiveVersion,
    sortTransformationRules,
    updateBrand,
    deleteTransformationRule,
    deleteBrandDataDefinition,
    getBrandSettings,
    updateBrandSettings,
    changeSftpPassword,
    deleteLookupDefinition,
    cloneDataDefinition,
    deleteBrandProduct,
    getProductsWithIds,
    duplicateProducts,
    editBrandVendorId,
    updateBrandSyncTime,
};

function updateTagLayout(data, id) {
    return SC.postCall("taglayout/" + id, data);
}

function getTagLayout(id) {
    return SC.getCall("taglayout/" + id);
}

function getBrandTagLayoutsPagination(id, filter, page, sort, pageSize, for_order = false) {
    return SC.getCall(`taglayout?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&brand_id=${id}&paginate=${true}&for_order=${for_order}`)
}

function deleteTagLayout(data) {
    return SC.deleteCall(`taglayout/` + data);
}

function saveTagLayout(data) {
    return SC.postCall("taglayout", data);
}

function storeCustomerBrand(brand_id, customer_id, data) {
    return SC.postCall(`assign/brand/${brand_id}/to/customer/${customer_id}`, data);
}

function editBrandVendorId(brand_id, customer_id, data) {
    return SC.postCall(`edit/brand/${brand_id}/to/customer/${customer_id}`, data);
}

function deleteCustomerBrand(brand_id, customer_id, data) {
    return SC.deleteCall(`remove/brand/${brand_id}/from/customer/${customer_id}`);
}

function getAllListTypes() {
    return SC.getCall("list_type");
}

function getListType(id) {
    return SC.getCall("list_type" + id);
}

function getBrandsList(page, filter, sort, pageSize) {
    return SC.getCall(
        `brands?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`
    );
}

function getBrandsListDropdown(page, filter, sort, pageSize) {
    return SC.getCall(
        `get-all-brands?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`
    );
}

function getAllBrands() {
    return SC.getCall(`brands/all`);
}

function getAllCustomerBrands(custId) {
    return SC.getCall(`customer/${custId}/brands`);
}

function getListItem(id) {
    return SC.getCall(`lists/${id}`);
}
function storeBrand(brandData) {
    return SC.postCall("brands", brandData);
}

function storeBrandProductAtts(prodData, id) {
    return SC.postCall(`add/brand/${id}/product/attributes`, prodData);
}

function storeBrandOrderAtts(orderData, id) {
    return SC.postCall(`add/brand/${id}/order/attributes`, orderData);
}

function storeBrandExportAtts(exportData, id) {
    return SC.postCall(`add/brand/${id}/export/attributes`, exportData);
}

function storeBrandDataDefinition(data, id) {
    return SC.postCall(`data/definition/${id}`, data);
}

function deleteBrand(brandId) {
    return SC.deleteCall(`brands/${brandId}`);
}

function editList(listData, list_id) {
    return SC.putCall("lists/" + list_id, listData);
}

function getBrandDataWithKey(brandId) {
    return SC.getCall(`get/brand/product_attribute/${brandId}`);
}

function getBrandProductData(brandId, page, filter, sort, pageSize) {
    return SC.getCall(
        `get/brand/product_data/${brandId}?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`
    );
}

function getBrandDataDefinitions(definitionId, page, filter, sort, pageSize) {
    return SC.getCall(
        `brand/${definitionId}/data/definitions?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}`
    );
}

function editBrandDataDefinition(definitionId, type) {
    return SC.getCall(`data/definition/${definitionId}/${type}`);
}

function storeTransformationRules(data, definitionId) {
    return SC.postCall(`add/data/definition/${definitionId}/rule`, data);
}

function storeBrandLookupTable(data, brandId) {
    return SC.postCall(`add/brand/${brandId}/lookup/table`, data);
}

function getBrandLookupDefinitionsPagination(brandId, page, filter, sort, pageSize) {
    return SC.getCall(`brand/${brandId}/lookup/definitions?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&paginate=true`);
}


function getBrandLookupDefinitionsData(brandId) {
    return SC.getCall(`brand/${brandId}/lookup/definitions`);
}

function getTransformationRulesListing(id, type) {
    return SC.getCall(`transformation/rules/${id}/listing?type=${type}`);
}

function markActiveVersion(data_definition_id) {
    return SC.getCall(`mark/data/definition/${data_definition_id}/active`);
}

function sortTransformationRules(data) {
    return SC.postCall(`sort/transformation/rules`, data);
}

function updateBrand(id, brandData) {
    return SC.postCall(`brands/${id}`, brandData);
}

function deleteTransformationRule(ruleId) {
    return SC.deleteCall(`delete/${ruleId}/transformation/rule`);
}

function deleteBrandDataDefinition(definitionId) {
    return SC.deleteCall(`data/definition/${definitionId}`);
}

function getBrandSettings(model, model_id) {
    return SC.getCall(`get/${model}/${model_id}/settings`);
}

function updateBrandSettings(id, brandData) {
    return SC.putCall(`update/settings`, brandData);
}

function changeSftpPassword(data) {
    return SC.postCall(`change/sftp/password`, data);
}

function deleteLookupDefinition(id) {
    return SC.deleteCall(`lookup/definition/${id}`);
}

function cloneDataDefinition(id) {
    return SC.getCall(`data/definition/${id}/clone`)
}

function deleteBrandProduct(data) {
    return SC.postCall(`brand-product/delete`, data)
}

function getProductsWithIds(data) {
    return SC.postCall(`brand-products`, data)
}
function duplicateProducts(data) {
    return SC.postCall(`duplicate/products`, data)
}

function updateBrandSyncTime(data) {
    return SC.postCall(`schedule-sync-job`, data)
}


// WEBPACK FOOTER //
// ./src/services/brand.js